const $inject = [];
const lbDebtorMultiSelect = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaDebtorMultiSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaDebtorMultiSelect.html')
  }
};

lbDebtorMultiSelect.$inject = $inject;

export default lbDebtorMultiSelect;



// WEBPACK FOOTER //
// ./src/components/lbaDebtorMultiSelect/lbaDebtorMultiSelectDir.js